var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.26 7.07 17 9.61V6.25A1.25 1.25 0 0 0 15.75 5H3.25A1.25 1.25 0 0 0 2 6.25v11.5A1.25 1.25 0 0 0 3.25 19h12.5A1.25 1.25 0 0 0 17 17.75v-3.36l4.26 2.54a.5.5 0 0 0 .74-.47V7.54a.5.5 0 0 0-.74-.47Z"
})));
export default SvgVideo;